import type { Hex } from 'viem';

import config from './config.json';

// eslint-disable-next-line no-restricted-properties
const { hostname, search } = window.location;
const urlParams = new URLSearchParams(search);

export const ALLOWED_ORIGIN = urlParams.get('allowedOrigin');

const getEnvConfig = () => {
  if (hostname.match(/sorare.(dev|tech)/)) {
    return config.staging;
  }
  if (hostname.match(/localhost|\.local$/)) {
    const { port } = document.referrer
      ? new URL(document.referrer)
      : // eslint-disable-next-line no-restricted-properties
        window.location;
    switch (port) {
      case '3003':
        return config.production;
      case '4003':
      case '5003':
        return config.staging;
      default:
        return config.local;
    }
  }
  if (hostname.match(/sorare.netlify.app/)) {
    return config.preview;
  }

  return config.production;
};

const envConfig = getEnvConfig();

export const RELAY_ADDRESS = envConfig.relayAddress;
export const ERC721_ADDRESS = envConfig.erc721Address;
export const MIGRATOR_ADDRESS = envConfig.migratorAddress! as Hex;
export const BANK_DEPOSIT_ADDRESS = envConfig.bankDepositAddress!;
export const EVM_ENDPOINT = envConfig.evmEndpoint;
export const EVERVAULT_CONFIG = envConfig.evervault;
export const ENCRYPTION_KEYS = {
  sorare: envConfig.sorareEncryptionKey,
  vaultinum: envConfig.vaultinumEncryptionKey,
};
export const SOLANA_RPC_ENDPOINT = envConfig.solanaRpcEndpoint;
